
import { Ekomi } from "src/lib/Ekomi";
import { Component, Prop, Vue } from "vue-property-decorator";
import { container } from '../lib/container';
import { ContainerTypes } from '../lib/core/types/ContainerTypes';

const ekomi = container.get<Ekomi>(ContainerTypes.Ekomi);

@Component
export default class EkomiStars extends Vue {
    @Prop() id!: number | null;
    @Prop({ default: 1 }) scale!: number;
    @Prop({ default: 'Default' }) mode!: string;

    width!: number;
    ratingWidth!: number;
    height!: number;
    rating!: number;
    reviews!: number;
    url!: string;
    isActive = false;
    isPopupInfoEnabled = false;

    get isDetailInfoEnabled() {
        return this.mode === 'Details';
    };

    $refs!: {
        link: HTMLElement;
    };

    onMouseenter(event: Event) {
        if (this.mode === 'Popup') {
            this.isPopupInfoEnabled = true;
        }
    }

    onMouseleave(event: Event) {
        if (this.mode === 'Popup') {
            this.isPopupInfoEnabled = false;
        }
    }

    onClick(event: Event) {
        event.stopPropagation();
    }

    mounted() {
        this.$nextTick(() => {
            ekomi.get(this.id)
                .then(summary => {
                    if (summary) {
                        const ratingFilled = Math.floor(summary.rating);
                        const filled = ratingFilled < 5 ? 71 * ratingFilled : 327;
                        const ratingPartial = summary.rating - ratingFilled;

                        this.ratingWidth = (filled + (43 * ratingPartial)) * this.scale;
                        this.width = this.scale * 327;
                        this.height = this.scale * 43;

                        this.rating = summary.rating;
                        this.reviews = summary.reviews;
                        this.url = summary.url;
                        
                        this.isActive = true;
                    }
                })
                .catch(console.error);
        });
    }

    getContainerStyles() {
        return {

        };
    }
    getStarsGrayStyles() {
        return {
            width: `${this.width}px`,
            height: `${this.height}px`,
            backgroundSize: `${this.width}px ${this.height}px`,
        };
    }
    getStarsYellowStyles() {
        return {
            width: `${this.ratingWidth}px`,
            height: `${this.height}px`,
            backgroundSize: `${this.width}px ${this.height}px`,
        };
    }
}
